//WE.Flow.Html.Contracts.Manifests.ModuleRole

export class ModuleRole {
    name: string = "";
    id: string = "";
    isEnabled: boolean = false;
}
